
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errorpJkoIAElqYhzL4J2s58SdJZ4FBdATgB95I_2AsycbvUMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/error.vue?macro=true";
import { default as indexhrCv50oj60BhgCpK8AYRxaBR_mI60gvp4TNuaaqF92kMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/dashboard/pages/index.vue?macro=true";
import { default as loginOs2CHMbcj_2xFwzyjzZGof54yVlilkx9v2eN3ujTihQMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/login.vue?macro=true";
import { default as searchzu_45HcbLVyfDmT2ZWOPc_45cpLssUB5zd6vju7izPMDyCgMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/search.vue?macro=true";
import { default as campaignsE0O8vWD0H5TLwVxzsD9fHh9_453_PBtuWHsKZBnY1_ndcMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/campaigns.vue?macro=true";
import { default as reportingqHHO30ZRQnWsitQWW2ZiZRU3qb0ER8u64qQhava6lfYMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/reporting.vue?macro=true";
import { default as ambassadorshZAOUAEAqdBA7TEZW07Z8ioaUwEAfMiXR03bPbmmMj0Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/ambassadors/pages/ambassadors.vue?macro=true";
import { default as _91id_93XNYJiAVg3YcmTMEwQsv0QNfI1A8CTFC1_45CtZ0VJwENcMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/tweets/[id].vue?macro=true";
import { default as indexNw9Y9WI2TVT3BMFexLXDAnJ3w5GBTKEobjlUKfgbn44Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/users/index.vue?macro=true";
import { default as _91id_93SjijnAbt5hgdlKy8AfvGQg_45pzIZA3wlnT5vP09gjJssMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/wallets/[id].vue?macro=true";
import { default as _91id_93EtRuCLCSjSHs7h_mn6TOmDfYkErg69ARvCK_45pmctB4sMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/creators/[id].vue?macro=true";
import { default as company_45profileEcbpE4h2HExq_xNOLiJjsZcy5gnsST4mm9XxTivXndwMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/advertiser-profile/pages/company-profile.vue?macro=true";
import { default as indexVp3HvqBKx5ARJzn7ZZ51P2uaiDQXx7qmTT93kY5A_b8Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/discovery/index.vue?macro=true";
import { default as _91token_93hLtwjx8QtCpNlgNfu7kWp3HBL0xXSDeSmUQtuQOelgsMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/payment/[token].vue?macro=true";
import { default as team_45managementB3VMOEQOvyydn3VCt7SMvqT_hpNH_459YA3_45xwfzlTv2IMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/teams/pages/team-management.vue?macro=true";
import { default as indexlmWBwS59xdf2lAXFFDG3zytjWAdHMqcMi5xYRQXYpkUMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/week/[id]/index.vue?macro=true";
import { default as indexIGyqh5itOIZFDQiQ7ZLN0Syk9_LOEethZ__452sl8YfUEMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/withdrawals/pages/withdrawals/index.vue?macro=true";
import { default as _91secret_93tnCw08I_taS6dZM2pxfd1o0WWIkWlDArAVO_45f2I8yJgMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/link/[lt]/[secret].vue?macro=true";
import { default as indexvtNre3YLi9wx0PX9CO_aWCPFyIqVgVuIoOH3gYp_5r4Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/test-helpers/index.vue?macro=true";
import { default as indexdW0QeMBnFjUy_qlzB6sc9m9nQx3tehL6PB_r2dILaDUMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/global-reports/index.vue?macro=true";
import { default as indexhO_EGz9sUdLLN9_454MXvVt_45FgnX0RP5zMJ7qHij2bTugMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/wizard/index.vue?macro=true";
import { default as new_45week_v4OzMHAighDIsZFWLZ_GXNuya9lUkiaiAc95fVd2ncMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/campaign/[id]/new-week.vue?macro=true";
import { default as index7XLKxtL15rJj2AQIGqHnZfsv09kS8o4V1hQCp5fnbBoMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/callback/index.vue?macro=true";
import { default as indexshqAs49x_ldsNhHEcQZoUk37T107Nmtj2obD4DiOG14Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/index.vue?macro=true";
import { default as direct_45messagesMarUq4pIsFm4ebCeWNTnUUJ2xmxhM9OwFNnHzyBq374Meta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/direct-messages.vue?macro=true";
import { default as indexHhR_Shb7wGJ3xF77cj3FwNtXEK_45BkMOBWj8NllA4HkQMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/templates/index.vue?macro=true";
import { default as _91number_938lymwv_TbwpssF_45ULjRXWxLDmUVkGUJN864_45FVYIH5wMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/week/[id]/segment/[number].vue?macro=true";
import { default as index_45ouG1O6zG2Dhz0TOU9pWh9QYyMHX_ROyHHFDLBTLBFoMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/[id]/index.vue?macro=true";
import { default as indexeV7T8IPfItqzdTtFZExWmZDeayadfXNcRbjygNLO3LUMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/index.vue?macro=true";
import { default as posts8SL8mOaarC8dGx5wqXfImgACOwvl1I_71oBj_450xs0lsMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/posts.vue?macro=true";
import { default as creatorsZ0EtfvlDj_45b5wqOAjtma4hw4SchWhw14Y7lvYKgI72MMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/creators.vue?macro=true";
import { default as indexNuQfIXJtfGMVI9Eteb5cLLTBRZlVgHvjzDlkHNQ5HdMMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/[id]/send/index.vue?macro=true";
import { default as indexqDkSNqSjLUEmdk_45NfPsm2uW6xfFN34_45Jm_45phNXoEKbcMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/index.vue?macro=true";
import { default as postsy_i5l_eHf4GrXQXjzag2_457Ip70AUpop5lpRisBusdhwMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/posts.vue?macro=true";
import { default as creatorsJgIvF8viIDe0Ihp27csQvC0SrzG4x1G7gOMPjrg5FUAMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/creators.vue?macro=true";
import { default as component_45stubvzdZeQgyN2GZIAPzwTz6M3bO7WmwIrippmVumIgkQDMMeta } from "/home/runner/work/evangelist-platform/evangelist-platform/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubvzdZeQgyN2GZIAPzwTz6M3bO7WmwIrippmVumIgkQDM } from "/home/runner/work/evangelist-platform/evangelist-platform/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "error",
    path: "/error",
    meta: errorpJkoIAElqYhzL4J2s58SdJZ4FBdATgB95I_2AsycbvUMeta || {},
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/dashboard/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginOs2CHMbcj_2xFwzyjzZGof54yVlilkx9v2eN3ujTihQMeta || {},
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/login.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/search.vue")
  },
  {
    name: "campaigns",
    path: "/campaigns",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/campaigns.vue")
  },
  {
    name: "reporting",
    path: "/reporting",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/reporting.vue")
  },
  {
    name: "ambassadors",
    path: "/ambassadors",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/ambassadors/pages/ambassadors.vue")
  },
  {
    name: "tweets-id",
    path: "/tweets/:id()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/tweets/[id].vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/users/index.vue")
  },
  {
    name: "wallets-id",
    path: "/wallets/:id()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/wallets/[id].vue")
  },
  {
    name: "creators-id",
    path: "/creators/:id()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/creators/[id].vue")
  },
  {
    name: "company-profile",
    path: "/company-profile",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/advertiser-profile/pages/company-profile.vue")
  },
  {
    name: "discovery",
    path: "/discovery",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/discovery/index.vue")
  },
  {
    name: "payment-token",
    path: "/payment/:token()",
    meta: _91token_93hLtwjx8QtCpNlgNfu7kWp3HBL0xXSDeSmUQtuQOelgsMeta || {},
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/payment/[token].vue")
  },
  {
    name: "team-management",
    path: "/team-management",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/teams/pages/team-management.vue")
  },
  {
    name: "week-id",
    path: "/week/:id()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/week/[id]/index.vue")
  },
  {
    name: "withdrawals",
    path: "/withdrawals",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/withdrawals/pages/withdrawals/index.vue")
  },
  {
    name: "link-lt-secret",
    path: "/link/:lt()/:secret()",
    meta: _91secret_93tnCw08I_taS6dZM2pxfd1o0WWIkWlDArAVO_45f2I8yJgMeta || {},
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/auth/pages/link/[lt]/[secret].vue")
  },
  {
    name: "test-helpers",
    path: "/test-helpers",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/support/pages/test-helpers/index.vue")
  },
  {
    name: "global-reports",
    path: "/global-reports",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/global-reports/index.vue")
  },
  {
    name: "messages-wizard",
    path: "/messages/wizard",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/wizard/index.vue")
  },
  {
    name: "campaign-id-new-week",
    path: "/campaign/:id()/new-week",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/campaign/[id]/new-week.vue")
  },
  {
    name: "messages-callback",
    path: "/messages/callback",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/callback/index.vue")
  },
  {
    name: "messages-campaigns",
    path: "/messages/campaigns",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/index.vue")
  },
  {
    name: "messages-direct-messages",
    path: "/messages/direct-messages",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/direct-messages.vue")
  },
  {
    name: "messages-templates",
    path: "/messages/templates",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/templates/index.vue")
  },
  {
    name: "week-id-segment-number",
    path: "/week/:id()/segment/:number()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/campaigns/pages/week/[id]/segment/[number].vue")
  },
  {
    name: "messages-campaigns-id",
    path: "/messages/campaigns/:id()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/[id]/index.vue")
  },
  {
    name: "report-campaignWeekId",
    path: "/report/:campaignWeekId()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/index.vue")
  },
  {
    name: "report-campaignWeekId-posts",
    path: "/report/:campaignWeekId()/posts",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/posts.vue")
  },
  {
    name: "report-campaignWeekId-creators",
    path: "/report/:campaignWeekId()/creators",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/creators.vue")
  },
  {
    name: "messages-campaigns-id-send",
    path: "/messages/campaigns/:id()/send",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/messages/pages/messages/campaigns/[id]/send/index.vue")
  },
  {
    name: "report-campaignWeekId-segmentId",
    path: "/report/:campaignWeekId()/:segmentId()",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/index.vue")
  },
  {
    name: "report-campaignWeekId-segmentId-posts",
    path: "/report/:campaignWeekId()/:segmentId()/posts",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/posts.vue")
  },
  {
    name: "report-campaignWeekId-segmentId-creators",
    path: "/report/:campaignWeekId()/:segmentId()/creators",
    component: () => import("/home/runner/work/evangelist-platform/evangelist-platform/apps/admin-frontend/layers/reports/pages/report/[campaignWeekId]/[segmentId]/creators.vue")
  },
  {
    name: component_45stubvzdZeQgyN2GZIAPzwTz6M3bO7WmwIrippmVumIgkQDMMeta?.name,
    path: "/messages",
    component: component_45stubvzdZeQgyN2GZIAPzwTz6M3bO7WmwIrippmVumIgkQDM
  }
]